const Styles = {
    'OverlayToggleButton': 'OverlayToggleButton_OverlayToggleButton--84de63be'
};

export default Styles;